/** IANA timezone of the current admin browser (sent to API when saving times). */
export function getBrowserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/** Display a stored UTC instant in the viewer's local timezone (UK 12-hour). */
export function formatEventTime(iso: string | undefined): string {
  if (!iso) return '';
  return new Date(iso).toLocaleTimeString('en-GB', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

/** 24h HH:mm for <input type="time"> in the viewer's local timezone. */
export function extractEventTimeForInput(iso: string): string {
  const d = new Date(iso);
  const hour = String(d.getHours()).padStart(2, '0');
  const minute = String(d.getMinutes()).padStart(2, '0');
  return `${hour}:${minute}`;
}
